import { render, staticRenderFns } from "./TabPanelDados.vue?vue&type=template&id=2c232b55&scoped=true&"
import script from "./TabPanelDados.vue?vue&type=script&lang=js&"
export * from "./TabPanelDados.vue?vue&type=script&lang=js&"
import style0 from "./TabPanelDados.vue?vue&type=style&index=0&id=2c232b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c232b55",
  null
  
)

export default component.exports